import React from "react";
import "../../../styles/globalStyles.css";
import styles from "./Web.module.css";
import { Globe, Cloud, Settings } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Package from "./Package";
import Support from "./Support";
import Seo from "./../../Seo";

export default function Web() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]);

  const goToPackages = () => {
    document.getElementById("packages")?.scrollIntoView({
      behavior: "smooth"
    });
  };

  const goToSupport = () => {
    document.getElementById("support")?.scrollIntoView({
      behavior: "smooth"
    });
  };

  return (
    <>
      <Seo
        title="Tworzenie stron internetowych"
        description="Projektujemy nowoczesne strony internetowe tworzone od podstaw. Responsywne, szybkie i dopasowane do potrzeb Twojej firmy."
        canonical="/web"
      />

      <section id="service" className="sectionContainer light">
        <div className={`${styles.titleWeb} "sectionTitle"`}>
          <h1>Tworzenie stron internetowych dopasowanych do Twojej firmy</h1>
        </div>
        <div className={styles.introduction}>
          <div className={styles.introText}>
            <p>
              Tworzymy strony internetowe dla firm, które chcą profesjonalnie
              zaprezentować swoją działalność w internecie. Łączymy indywidualny
              projekt, czysty kod oraz rozwiązania dopasowane do rzeczywistych
              potrzeb klienta.
            </p>
          </div>
          <div className={styles.introLink}>
            <button onClick={goToPackages} className={styles.introLinkElement}>
              Zobacz pakiety
            </button>

            <button onClick={goToSupport} className={styles.introLinkElement}>
              Poznaj opcje wsparcia
            </button>
          </div>
        </div>
        <div className={styles.serviceContent}>
          <div className={styles.serviceItem}>
            <h2 className={styles.serviceTitle}>Strony internetowe</h2>
            <div className={styles.container}>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  Projektujemy proste, funkcjonalne i estetyczne strony WWW.
                  Dbamy o przejrzystość, intuicyjną nawigację i responsywność,
                  dzięki czemu strony działają dobrze na każdym urządzeniu.
                  Każdy projekt tworzymy indywidualnie, kodując stronę od
                  podstaw bez gotowych szablonów i ograniczeń typowych dla
                  popularnych kreatorów stron. Dzięki temu możemy tworzyć
                  szybkie, bezpieczne i dopasowane do potrzeb klienta
                  rozwiązania.
                </p>
              </div>
              <div className={styles.iconContainer}>
                <Globe
                  className={`${styles.iconWeb} ${styles.loader}`}
                  size={70}
                />
              </div>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <h2 className={styles.serviceTitle}>Hosting i domeny</h2>
            <div className={styles.container}>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  Oferujemy pomoc w doborze bezpiecznego i stabilnego hostingu
                  dopasowanego do potrzeb Twojej strony. Wspieramy również w
                  procesie konfiguracji domeny, certyfikatu SSL oraz niezbędnych
                  ustawień technicznych. Dbamy o to, aby strona działała szybko,
                  stabilnie i była przygotowana do bezpiecznego użytkowania.
                  Zalecamy, aby usługi hostingowe były zakładane na dane
                  klienta, dzięki czemu zachowuje on pełną kontrolę i
                  niezależność nad swoją stroną internetową.
                </p>
              </div>
              <div className={styles.iconContainer}>
                <Cloud className={styles.iconWeb} size={70} />
              </div>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <h2 className={styles.serviceTitle}>SEO</h2>
            <div className={styles.container}>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  Dbamy o widoczność strony w internecie poprzez podstawowe
                  działania SEO – zarówno techniczne, jak i treściowe.
                  Przygotowujemy stronę zgodnie z dobrymi praktykami
                  wyszukiwarek, pomagamy w konfiguracji Google Analytics 4 i
                  Google Search Console oraz wskazujemy elementy wymagające
                  dalszej optymalizacji. Nie prowadzimy kampanii Google Ads ani
                  kompleksowych działań pozycjonerskich. Koncentrujemy się na
                  solidnych podstawach, które wspierają widoczność strony.
                </p>
              </div>
              <div className={styles.iconContainer}>
                <div className={styles.image}>
                  <img
                    src={`${process.env.PUBLIC_URL}/Images/Services/seo.webp`}
                    alt="optymalizacja SEO"
                    className={styles.imageIcon}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <h2 className={styles.serviceTitle}>Projekty graficzne</h2>
            <div className={styles.container}>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  Przygotowujemy podstawowe materiały graficzne dopasowane do
                  Twojej marki i strony internetowej. Tworzymy grafiki, banery,
                  ikony oraz inne elementy wizualne, które pomagają zachować
                  spójny i estetyczny wygląd projektu.
                </p>
              </div>
              <div className={styles.iconContainer}>
                <div className={styles.image}>
                  <img
                    src={`${process.env.PUBLIC_URL}/Images/Services/graphic.webp`}
                    alt="Materiały graficzne do strony internetowej"
                    className={styles.imageIcon}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.packageTitle}>
          <h2>Poznaj nasze pakiety</h2>
        </div>

        {/* ---------------------------------------------------------- */}

        <div className={styles.infoForClient}>
          <p>
            Każda strona jest tworzona indywidualnie, dlatego przedstawione
            pakiety stanowią orientacyjny zakres usług. Ostateczna cena zależy
            od funkcjonalności, liczby podstron oraz indywidualnych potrzeb
            projektu.
          </p>
        </div>

        {/* ---------------------------------------------------------- */}

        <Package />
        <Support />

        {/* ---------------------------------------------------------- */}
        <div className={styles.list}>
          <h3>Usługi dodatkowe</h3>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              {" "}
              <Settings />
            </span>
            <span>Konsultacje online: 100zł/godz.</span>
          </div>

          <div className={styles.listItem}>
            <span className={styles.icon}>
              {" "}
              <Settings />
            </span>
            <span>Konsultacje stacjonarne: od 200zł.</span>
          </div>

          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>Aktualizacja treści na stronie: od 100zł.</span>
          </div>

          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>Dodatkowa podstrona/komponent: od 300zł.</span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span> Projekt i wdrożenie formularza kontaktowego: od 300zł.</span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings w />
            </span>
            <span> Optymalizacja SEO(techniczna lub treściowa): od 300zł.</span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>
              {" "}
              Pomoc w przygotowaniu treści na stronę: wycena indywidualna.
            </span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>
              {" "}
              Materiały graficzne na potrzeby strony: wycena indywidualna.
            </span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>
              {" "}
              Integracje z zewnętrznymi systemami (CRM, newsletter, płatności,
              rezerwacje itp.): wycena indywidualna.
            </span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>
              {" "}
              Konfiguracja Google Analytics 4 + Search Console + wdrożenie
              banera cookie z możliwością zarządzania zgodami": 400 zł.
            </span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span> Wdrożenie polityki prywatności: 280 zł.</span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>Wdrożenie funkcji dostępności (WCAG): od 300 zł.</span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span>Modernizacja istniejącej strony: od 300zł.</span>
          </div>
          <div className={styles.listItem}>
            <span className={styles.icon}>
              <Settings />
            </span>
            <span> Migracja strony na nowy hosting / domenę: od 250 zł.</span>
          </div>
        </div>
        <div className={styles.additionInfoAboutPrice}>
          <p>
            Podane ceny są orientacyjne i stanowią kwoty wyjściowe. Każdy
            projekt jest wycenainy indywidualnie. Ostateczny koszt zależy od zakresu
            prac, wymaganych funkcjonalności oraz stopnia skomplikowania
            realizacji.
          </p>
        </div>
        <div className={styles.additionInfoAboutContact}>
          <p>
            Jeśli masz pytania dotyczące szkolenia lub nie wiesz, który kurs
            będzie najlepszy, chętnie pomożemy. Skontaktuj się z nami{" "}
            <a href="/#contact" className={styles.contactInfo}>
              telefonicznie, przez formularz kontaktowy lub e-mail.
            </a>{" "}
            Zachęcamy również do odwiedzenia sekcji{" "}
            <a href="/#faq" className={styles.contactInfo}>
              FAQ
            </a>
            , gdzie zebraliśmy odpowiedzi na najczęściej zadawane pytania.
          </p>
        </div>

        <div className="buttonSection">
          <div className="backButtonContainer">
            <button
              className="backButton"
              onClick={() => window.history.back()}
            >
              Powrót
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
